import React from 'react';
import Form from 'global/components/form';
import Modal from '../../../global/components/modal';

const UserGroupForm = props => {
  return (
    <div>
      <Form
        showAllScreens
        onSubmit={props.onSubmit}
        submitText="Submit"
        canSubmit={true}
        submitBtnBoxStyle={{ position: 'relative' }}
        useCheckContinue
        screens={[
          {
            title: 'User Group',
            inputs: [
              {
                id: 'name',
                type: 'TextField',
                props: {
                  label: 'Name',
                  required: true,
                }
              },
              {
                id: 'description',
                type: 'TextField',
                props: {
                  label: 'Description',
                }
              }
            ]
          }
        ]}
      />
    </div>
  )
}

export const UserGroupModal = props => {
  return (
    <Modal {...props}>
      <UserGroupForm onSubmit={props.onSubmit} />
    </Modal>
  )
}